import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ShoppingBag, Rocket, Truck } from "lucide-react";
import { trackEvent } from "@/lib/retention";

/**
 * Sticky bottom-of-viewport CTA bar — mobile only (<md). Always shows the
 * three highest-value entry points: Shop, Affiliate, Supplies.
 *
 * Hidden inside the authenticated shell + on the cart/checkout pages where
 * the user is already mid-conversion.
 */
const HIDDEN_PATHS = new Set(["/cart", "/auth/login", "/auth/register"]);

export default function MobileCTABar() {
  const loc = useLocation();
  if (HIDDEN_PATHS.has(loc.pathname)) return null;

  return (
    <nav
      data-testid="mobile-cta-bar"
      aria-label="Quick navigation"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-black/85 backdrop-blur-md border-t border-white/10"
      style={{ paddingBottom: "max(env(safe-area-inset-bottom), 6px)" }}
    >
      <div className="grid grid-cols-3 divide-x divide-white/5">
        <Link
          to="/shop"
          data-testid="mobile-cta-shop"
          onClick={() => trackEvent("section_engagement", { cta: "shop", surface: "mobile_bar" })}
          className="flex flex-col items-center justify-center gap-1 py-2.5 text-[0.65rem] font-bebas tracking-[0.18em] uppercase text-lifted-text active:bg-white/5"
        >
          <ShoppingBag className="h-4 w-4" aria-hidden="true" />
          Shop
        </Link>
        <Link
          to="/affiliate-zone"
          data-testid="mobile-cta-affiliate"
          onClick={() => trackEvent("affiliate_cta_click", { surface: "mobile_bar" })}
          className="flex flex-col items-center justify-center gap-1 py-2.5 text-[0.65rem] font-bebas tracking-[0.18em] uppercase text-lifted-green active:bg-white/5"
        >
          <Rocket className="h-4 w-4" aria-hidden="true" />
          Affiliate
        </Link>
        <Link
          to="/supplies"
          data-testid="mobile-cta-supplies"
          onClick={() => trackEvent("supplies_cta_click", { surface: "mobile_bar" })}
          className="flex flex-col items-center justify-center gap-1 py-2.5 text-[0.65rem] font-bebas tracking-[0.18em] uppercase text-lifted-text active:bg-white/5"
        >
          <Truck className="h-4 w-4" aria-hidden="true" />
          Supplies
        </Link>
      </div>
    </nav>
  );
}
